export class VoceCorrelataClassificaVO {
    id: string;
    codice: string;
    nome: string;
    motivo: string;
    nota: string;
    output: string;
}